import ProductTranspactInboundOutbound from "@/components/drawers/ProductDrawer/ProductTranspactInboundOutbound";
import ProductTransportImpactPerType from "@/components/drawers/ProductDrawer/ProductTransportImpactPerType";
import NoImpactBanner from "@/components/NoImpactBanner/NoImpactBanner";
import { useDashboardYear } from "@/pages/dashboard/hooks/useDateRange";
import { useDashboardOrderCounts } from "@/pages/dashboard/hooks/usePoSo";
import {
  ProductBy,
  useProductTransportImpactPerMode,
} from "@/pages/dashboard/hooks/useProductImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";

function TransportImpactPerProduct({
  metric: type,
  productId,
  by,
}: {
  metric: ImpactMetric;
  productId: number;
  by: ProductBy;
}) {
  const { data } = useProductTransportImpactPerMode({ productId, by, metric: type.key });

  const { data: orderCounts } = useDashboardOrderCounts({ productId });
  const { year } = useDashboardYear();

  if (orderCounts?.total === 0) {
    return (
      <NoImpactBanner title={`No transport impact for this product in ${year}`}>
        <span>
          This product was not found in any <strong>sales or purchase orders</strong> in {year}, so
          no impact could be calculated. Navigate to a different year, or upload{" "}
          <Link to="/orders/purchase_orders">orders</Link>.
        </span>
      </NoImpactBanner>
    );
  }

  if (data?.length === 0) {
    return (
      <NoImpactBanner
        title={`No transport impact for ${year}`}
        size="small"
      >
        <span>
          Check if you've uploaded <Link to={`/facilities`}>transport</Link> data for the routes of
          this product.
        </span>
      </NoImpactBanner>
    );
  }

  return (
    <Row gutter={[10, 10]}>
      <Col span={12}>
        <ProductTransportImpactPerType
          productId={productId}
          metric={type}
          by={by}
        />
      </Col>
      <Col span={12}>
        <ProductTranspactInboundOutbound
          productId={productId}
          metric={type}
          by={by}
        />
      </Col>
    </Row>
  );
}

export default TransportImpactPerProduct;
